import React from "react";

import iconRoulette from "@/assets/svg/roulette.svg";
import iconSoccer from "@/assets/svg/soccer.svg";

import { CampaignType } from "@/@types/campaign-roulette";

const BRAND_COLOR = "#4B303C";

const COPY = {
  HEADER_TITLE: "Tipo de sorteio",
  HEADER_DESCRIPTION: "Escolha o formato que será usado para definir o vencedor.",
} as const;

const OPTION_TITLES: Record<CampaignType, string> = {
  ROULETTE: "Roleta",
  WORLD_CUP: "Copa do Mundo",
};

const OPTION_DESCRIPTIONS: Record<CampaignType, string> = {
  ROULETTE: "Sorteio aleatório entre os participantes.",
  WORLD_CUP: "Chute ao gol com prêmios aleatórios",
};

const OPTION_ICONS: Record<CampaignType, string> = {
  ROULETTE: iconRoulette,
  WORLD_CUP: iconSoccer,
};

const OPTION_ORDER: CampaignType[] = [CampaignType.ROULETTE, CampaignType.WORLD_CUP];

const STYLES = {
  WRAPPER: "grid grid-cols-1 md:grid-cols-2 gap-4",
  CARD_BASE:
    "flex flex-col items-center justify-center text-center gap-3 rounded-lg border bg-white p-6 transition focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4B303C]",
  CARD_SELECTED: "border-[#4B303C]",
  CARD_IDLE: "border-gray-200 hover:border-gray-300",
  CARD_DISABLED: "opacity-60 cursor-not-allowed",
  CARD_INTERACTIVE: "cursor-pointer",
  ICON_WRAPPER: "flex h-16 w-16 items-center justify-center",
  ICON: "h-10 w-10",
  TITLE_BASE: "font-semibold",
  TITLE_SELECTED: "text-[#4B303C]",
  TITLE_IDLE: "text-gray-700",
  DESCRIPTION: "text-sm text-gray-500 mt-1",
  HEADER_TITLE: "text-sm font-medium mb-1",
  HEADER_DESCRIPTION: "text-xs text-gray-500 mb-3",
} as const;

interface CampaignTypeSelectorProps {
  value: CampaignType;
  onChange: (value: CampaignType) => void;
  disabled?: boolean;
}

export const CampaignTypeSelector: React.FC<CampaignTypeSelectorProps> = ({
  value,
  onChange,
  disabled,
}) => {
  return (
    <div>
      <p className={STYLES.HEADER_TITLE}>{COPY.HEADER_TITLE}</p>
      <p className={STYLES.HEADER_DESCRIPTION}>{COPY.HEADER_DESCRIPTION}</p>
      <div className={STYLES.WRAPPER}>
        {OPTION_ORDER.map((optionValue) => {
          const isSelected = value === optionValue;
          const title = OPTION_TITLES[optionValue];
          return (
            <button
              key={optionValue}
              type="button"
              disabled={disabled}
              onClick={() => onChange(optionValue)}
              aria-pressed={isSelected}
              style={isSelected ? { borderColor: BRAND_COLOR } : undefined}
              className={[
                STYLES.CARD_BASE,
                isSelected ? STYLES.CARD_SELECTED : STYLES.CARD_IDLE,
                disabled ? STYLES.CARD_DISABLED : STYLES.CARD_INTERACTIVE,
              ].join(" ")}
            >
              <div className={STYLES.ICON_WRAPPER}>
                <img
                  src={OPTION_ICONS[optionValue]}
                  alt={title}
                  className={STYLES.ICON}
                />
              </div>
              <div>
                <p
                  className={[
                    STYLES.TITLE_BASE,
                    isSelected ? STYLES.TITLE_SELECTED : STYLES.TITLE_IDLE,
                  ].join(" ")}
                >
                  {title}
                </p>
                <p className={STYLES.DESCRIPTION}>
                  {OPTION_DESCRIPTIONS[optionValue]}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
